import React, { useState, useEffect } from "react";
import axios from "axios";
import { message, Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { InputItem, ModalItem, SelectItem } from "../../../../../Components/Items";
import { TIPOS_SECCION, descripcionTipo, AyudaTiposSeccion } from "./tiposSeccionConstants";

const { Option } = Select;

const valoresIniciales = { codigo: "", nombre: "", tipo: "almacenamiento" };

const ModalAgregarSeccion = ({ visible, onClose, empresaId, proyectoId, mapaAlmacenId, headersToken, onCreado }) => {
  const [valores, setValores] = useState(valoresIniciales);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (visible) setValores(valoresIniciales);
  }, [visible]);

  const actualizar = (cambios) => setValores((prev) => ({ ...prev, ...cambios }));

  const crear = async () => {
    //Código y nombre son obligatorios en el modelo del backend (ver agregarSeccionAlmacen)
    const codigo = (valores.codigo || "").trim();
    const nombre = (valores.nombre || "").trim();
    if (!codigo || !nombre) {
      message.error("El código y el nombre de la sección son obligatorios");
      return;
    }

    const limitesVisuales = { x: 40, y: 40, ancho: 280, alto: 220 };
    setGuardando(true);
    try {
      const res = await axios.post(
        "mapaAlmacen/agregarSeccionAlmacen",
        {
          empresaId,
          proyectoId,
          mapaAlmacenId,
          codigo,
          nombre,
          tipo: valores.tipo,
          limitesVisuales,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        onCreado({
          _id: res.data.seccionAlmacenId,
          mapaAlmacenId,
          codigo,
          nombre,
          tipo: valores.tipo,
          limitesVisuales,
          activa: true,
        });
        onClose();
      } else {
        message.error(res.data.error || "No se pudo crear la sección");
      }
    } catch (error) {
      console.error("Error al crear la sección:", error);
      message.error("No se pudo crear la sección");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <ModalItem
      title="Agregar sección"
      visible={visible}
      onCancel={onClose}
      onOk={crear}
      width={520}
      footer
      spinning={guardando}
      confirmLoading={guardando}
    >
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Código</div>
        <InputItem value={valores.codigo} onChange={(e) => actualizar({ codigo: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre</div>
        <InputItem value={valores.nombre} onChange={(e) => actualizar({ nombre: e.target.value })} />
      </div>
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4, color: "#6b7280" }}>
          <span>Tipo</span>
          <Tooltip title={AyudaTiposSeccion} placement="right">
            <InfoCircleOutlined style={{ cursor: "help", color: "#8a93a6" }} />
          </Tooltip>
        </div>
        <SelectItem width="100%" value={valores.tipo} onChange={(value) => actualizar({ tipo: value })}>
          {TIPOS_SECCION.map((t) => (
            <Option key={t.value} value={t.value} title={t.descripcion}>
              {t.label}
            </Option>
          ))}
        </SelectItem>
        <div style={{ fontSize: 11, color: "#8a93a6", marginTop: 4 }}>{descripcionTipo(valores.tipo)}</div>
      </div>
    </ModalItem>
  );
};

export default ModalAgregarSeccion;
